import { render } from "./CheckoutWarning.vue?vue&type=template&id=54fd692a"
import script from "./CheckoutWarning.vue?vue&type=script&lang=js"
export * from "./CheckoutWarning.vue?vue&type=script&lang=js"

import "./CheckoutWarning.vue?vue&type=style&index=0&id=54fd692a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__